<template>
  <v-card-actions justify="space-between">
    <router-link :to="link">
    <v-btn large  text-align="center">{{text}}</v-btn>
    </router-link>
  </v-card-actions>
</template>

<script>
export default {
  name: 'ToolButton',
  components: {
  },
  props: ['link', 'text'],
  data () {
    return {
    }
  }
}
</script>
